import { CountryCode } from '~/enums'

// Countries the phone country picker offers. Must match the backend default
// in `config/phone.php` (mealz-api) — see
// tests/phone-config-country-contract.test.mjs.
export const phoneConfig = {
  allowedCountries: [CountryCode.US]
} as const
